import { Component, input, Input, InputSignal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import {
  TiimeOptionModule,
  TiimeButtonModule,
  TiimeIconModule,
  TiimeSelectModule,
  TiimeTableModule,
  TiimeTooltipModule
} from 'tiime-material';

import { GiFilesFormTableBase } from '@bases/gi-files-form-table/gi-files-form-table.base';
import { MissionAcceptanceFileType } from '@enums/mission-acceptance-file-type.enum';
import { MissionAcceptanceFileForm } from '@forms/mission-acceptance-file-form';
import { User } from '@models/user';
import { SimpleCellComponent } from '@shared-cells/simple-cell/simple-cell.component';
import { AtByPipe } from '@shared-pipes/at-by/at-by.pipe';
import { CodeAndLabelPipe } from '@shared-pipes/code-and-label/code-and-label.pipe';
import { IncludesPipe } from '@shared-pipes/includes/includes.pipe';
import { UserSelectComponent } from '@shared-selectors/user-select/user-select.component';

@Component({
  selector: 'app-mission-acceptance-files-form-table',
  standalone: true,
  imports: [
    CodeAndLabelPipe,
    TiimeIconModule,
    TiimeOptionModule,
    ReactiveFormsModule,
    SimpleCellComponent,
    TiimeButtonModule,
    TiimeSelectModule,
    TiimeTableModule,
    TiimeTooltipModule,
    UserSelectComponent,
    IncludesPipe,
    AtByPipe
  ],
  templateUrl: './mission-acceptance-files-form-table.component.html',
  styleUrl: './mission-acceptance-files-form-table.component.scss'
})
export class MissionAcceptanceFilesFormTableComponent extends GiFilesFormTableBase<MissionAcceptanceFileType, string> {
  @Input({ required: true }) filesForms: MissionAcceptanceFileForm[];
  readonly users: InputSignal<User[]> = input.required<User[]>();
  readonly displayedColumns: InputSignal<string[]> = input([
    'name',
    'createdAtBy',
    'title',
    'type',
    'contact',
    'actions'
  ]);

  readonly MissionAcceptanceFileType = MissionAcceptanceFileType;
}
